// extracted by mini-css-extract-plugin
export default {"about":"About_about__xUADO","head":"About_head__YYS5S","button":"About_button__NCka0"};